module.exports = __webpack_public_path__ + "static/media/local_storage.692848e0.svg";